export default __webpack_public_path__ + "67bf3ff761b748c2aa6193c4babd247c.jpg";